import { getSession } from "next-auth/react";

const userIdFormLoadTransaction = async (event: any) => {
    const session: any = await fetchUser();
    return {
        layoutChanged: false,
        dataChanged: true,
        newFormData: {
            user: {label: session?.user?.user?.email, value: session?.user?.user?.id}
        }
    }
}

const fetchUser = async () => {
    let session: any = await getSession();
    return session;
}
export default userIdFormLoadTransaction;